import { ReactComponent as Spinner } from '../../assets/icons/three-dots.svg'

export default Spinner
